import { Suspense } from "react"
import { useRoutes } from "react-router-dom"

import { PageLoading } from "@shared/ui"

import { ROUTES } from "../config"
import { AuthProvider } from "../providers"


export function WithRoutes(){
    const routing = useRoutes(ROUTES)
    return (
        <Suspense fallback={<PageLoading/>}>
            <AuthProvider>
                {routing}
            </AuthProvider>
        </Suspense>
    )
}